import { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { Outlet } from "react-router";
import { HiOutlineCog6Tooth } from "react-icons/hi2";
import { IoNotificationsOutline } from "react-icons/io5";
import { RxEnvelopeClosed } from "react-icons/rx";
import logo from "../assets/images/logo-white.png";
import user from "../assets/images/avatar.jpg";
import Profile from "../components/Header/Profile";
import SideMenu from "../components/Sidebar/SideMenu";
import { AuthContext } from "../contexts/AuthContext";
import Upcoming from "../components/Sidebar/Upcoming";

export default function MainLayout() {
  const { auth } = useContext(AuthContext);
  const [isVisible, setVisible] = useState(false);

  const menus = [
    { id: 1, name: "Calendar", to: "/calendar", hasMore: false },
    { id: 2, name: "Trainings", to: "/trainings", hasMore: false },
    { id: 3, name: "Courses", to: "/courses", hasMore: false },
    {
      id: 4,
      name: "Members",
      to: `${
        auth?.accessLevel === 7  ? "/members" : `/members/${auth?.company?._id}`
      }`,
      hasMore: false,
    },
  ];
  return (
    <div className="flex relative font-toyota">
      <div className="w-64 min-h-screen bg-white shadow-xl border-gray-300">
        <div className="h-16 border-r border-red-400 bg-toyota flex justify-start items-center px-4">
          <img src={logo} alt="" width={50} />
          <div className="flex flex-col items-start justify-start ml-1">
            <Link
              to="/dashboard"
              className="text-white text-xl tracking-wider font-bold"
            >
              TTL TRAINING
            </Link>
          </div>
        </div>
        <div className="border-r">
          <div className="">
            <div className="flex flex-col justify-center items-center pt-6 px-6">
              <Link
                to="/profile"
                className="w-16 h-16 rounded-full bg-gray-200"
              >
                <div className="p-1 bg-gray-300 h-full w-full rounded-full">
                  <img
                    src={user}
                    alt=""
                    className="w-full h-full rounded-full"
                  />
                </div>
              </Link>
              <div className="mt-4 flex flex-col justify-center items-center">
                <div className="font-bold">{auth?.name}</div>
                <div className="text-xs text-gray-400">{auth?.email}</div>
              </div>

              <div className="flex justify-between mt-6">
                <Link
                  to={`/settings`}
                  className="flex flex-col w-full h-full rounded-full bg-gray-100 p-3 mx-2 hover:bg-gray-200"
                >
                  <div className="">
                    <HiOutlineCog6Tooth size={20} />
                  </div>
                </Link>
                <Link
                  to={`/messages`}
                  className="flex flex-col w-full h-full rounded-full bg-gray-100 p-3 mx-2 hover:bg-gray-200"
                >
                  <div className="">
                    <RxEnvelopeClosed size={17} />
                  </div>
                </Link>
                <Link
                  to={`/notifications`}
                  className="flex flex-col w-full h-full rounded-full bg-gray-100 p-3 mx-2 hover:bg-gray-200"
                >
                  <div className="">
                    <IoNotificationsOutline size={19} />
                  </div>
                </Link>
              </div>
            </div>

            <Upcoming />
            <div className="border-t w-full mb-6 flex flex-col items-start">
              {menus?.map((item: any, index: number) => (
                <SideMenu menu={item} key={index} />
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="flex-1 bg-gray-100">
        <div className="h-16  bg-toyota flex w-full items-center px-2">
          <div className="flex justify-between items-center w-full">
            <div className="text-white font-bold uppercase">
              {auth?.company?.name}
            </div>
            <div className=""></div>
          </div>
          <Profile isVisible={isVisible} setVisible={setVisible} auth={auth} />
        </div>

        <div className="">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
